import {JsonConverter, JsonCustomConvert} from 'json2typescript';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {Condition} from '../model/Conditions/Condition';
import {QuestionCondition} from '../model/Conditions/QuestionCondition';

@JsonConverter
export class ConditionArrayConverter implements JsonCustomConvert<Array<Condition>> {

    deserialize(json: any): Array<Condition> {

        const socialMediaArr = Array<Condition>();
        // return
        /*const temp:TSMap<string,string>= new TSMap();
        for (const key of Object.keys(json)) {
            temp.set(key, json[key]);
        }

        return temp;*/

        for(const item of json) {
            if (item.conditionClass === 'simple') {
                socialMediaArr.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(item,QuestionCondition));
            }

        }

        return socialMediaArr;
    }

    serialize(data: Array<Condition>): any {
        return JSON.stringify(data);
    }
}
